var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Icon } from '../../utils/icon-utils.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let ColorpickerComponent = class ColorpickerComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.showColorpicker = false;
        this.selectedColor = '#5679C0';
        this.isDragging = false;
        this.hue = 208;
        this.saturation = 100;
        this.brightness = 50;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('focusout', this.handleFocusOut.bind(this));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('focusout', this.handleFocusOut.bind(this));
    }
    firstUpdated() {
        this.container = this.shadowRoot?.querySelector('.slds-color-picker') ?? null;
    }
    handleFocusOut(event) {
        if (!this.container?.contains(event.relatedTarget)) {
            this.showColorpicker = false;
            this.requestUpdate();
        }
    }
    handleColorChange(event) {
        const input = event.target;
        this.selectedColor = input.value;
        this.requestUpdate();
    }
    toggleDialog() {
        this.showColorpicker = !this.showColorpicker;
        this.requestUpdate();
    }
    handleHueChange(event) {
        const input = event.target;
        this.hue = parseInt(input.value, 10);
        this.updateSelectedColor();
    }
    updateSelectedColor() {
        this.selectedColor = this.hslToHex(this.hue, this.saturation, this.brightness);
        this.requestUpdate();
    }
    hslToHex(h, s, l) {
        s /= 100;
        l /= 100;
        const k = (n) => (n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
        return ('#' +
            Math.round(f(0) * 255).toString(16).padStart(2, '0') +
            Math.round(f(8) * 255).toString(16).padStart(2, '0') +
            Math.round(f(4) * 255).toString(16).padStart(2, '0'));
    }
    render() {
        return html `
    <div class="slds-color-picker" tabindex="0" style="display: inline-block;">
      <div class="slds-form-element slds-color-picker__summary">
        <div class="slds-form-element__control">
          <button class="slds-button slds-color-picker__summary-button slds-button_icon slds-button_icon-more" title="Choose Color" @click="${this.toggleDialog}">
            <span class="slds-swatch" style="background:${this.selectedColor}">
              <span class="slds-assistive-text">${this.selectedColor}</span>
            </span>
            ${Icon.getSVGIconTag({
            icon: 'down',
            sprite: 'utility',
            classes: ['slds-button__icon', 'slds-button__icon_small', 'slds-m-left_xx-small'],
        })}
            <span class="slds-assistive-text">Choose a color. Current color: ${this.selectedColor}</span>
          </button>
        </div>
      </div>
      <section aria-describedby="dialog-body-id-35" aria-label="Choose a color" class="slds-popover slds-color-picker__selector ${this.showColorpicker ? "slds-show" : "slds-hide"}" role="dialog">
        <div class="slds-popover__body" id="dialog-body-id-35">
          <div class="slds-media">
            <div class="slds-media__body">
              <div class="slds-tabs_default">
                <div id="color-picker-custom" class="slds-tabs_default__content slds-show" role="tabpanel" aria-labelledby="color-picker-custom__item">
                  <div class="slds-color-picker__custom">
                    <p id="color-picker-instructions" class="slds-assistive-text">Use arrow keys to select a saturation and brightness, on an x and y axis.</p>
                    <div class="slds-color-picker__custom-range" style="background:${this.selectedColor}" @mousedown="${this.startDragging}" @mouseup="${this.stopDragging}" @mousemove="${this.handleDrag}">
                      <div class="slds-color-picker__range-indicator" style="bottom:${this.brightness}%;left:${this.saturation}%" aria-live="assertive" aria-atomic="true" aria-describedby="color-picker-instructions">
                        <span class="slds-assistive-text">hex ${this.selectedColor}</span>
                      </div>
                    </div>
                    <div class="slds-color-picker__hue-and-preview">
                      <label class="slds-assistive-text" for="color-picker-input-range-27">Select Hue</label>
                      <input type="range" class="slds-color-picker__hue-slider" min="0" max="360" id="color-picker-input-range-27" .value="${this.hue}" @input="${this.handleHueChange}" />
                      <span class="slds-swatch" style="background:${this.selectedColor}">
                        <span class="slds-assistive-text" aria-hidden="true">${this.selectedColor}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="slds-color-picker__custom-inputs" style="padding-top:0">
                  <div class="slds-form-element slds-color-picker__input-custom-hex" style="display: flex; align-items: center;width: 100%;">
                    <label class="slds-form-element__label" for="color-picker-input-hex-29" style="margin-right: 8px;">Hex</label>
                    <div class="slds-form-element__control" style="flex-grow: 1;">
                      <input type="text" id="color-picker-input-hex-29" class="slds-input" style="width: 100%;" .value="${this.selectedColor}" @input="${this.handleHexChange}" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    `;
    }
    startDragging(event) {
        this.isDragging = true;
    }
    stopDragging(event) {
        this.isDragging = false;
    }
    handleDrag(event) {
        if (!this.isDragging)
            return;
        const rangeElement = this.shadowRoot?.querySelector('.slds-color-picker__custom-range');
        const rect = rangeElement.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        this.saturation = Math.min(Math.max(x / rect.width, 0), 1) * 100;
        this.brightness = 100 - Math.min(Math.max(y / rect.height, 0), 1) * 100;
        this.updateSelectedColor();
    }
    handleHexChange(event) {
        const input = event.target;
        const newColor = input.value;
        if (this.isValidHex(newColor)) {
            this.selectedColor = newColor;
            this.requestUpdate();
        }
        else {
            console.error('Invalid hex color');
        }
    }
    isValidHex(color) {
        return /^#[0-9A-F]{6}$/i.test(color);
    }
};
ColorpickerComponent = __decorate([
    customElement('ggo-colorpicker')
], ColorpickerComponent);
export { ColorpickerComponent };
